const getRequestConst = (unique) => `${unique}_REQUEST`;
const getSuccessConst = (unique) => `${unique}_SUCCESS`;
const getFailConst = (unique) => `${unique}_FAIL`;
const getOpenConst = (unique) => `${unique}_OPEN`;
const getCloseConst = (unique) => `${unique}_CLOSE`;

export const MTB_CLEAR_DIRECT_BREADCRUMBS = 'MTB_CLEAR_DIRECT_BREADCRUMBS';
export const MTB_ADD_DIRECT_BREADCRUMBS = 'MTB_ADD_DIRECT_BREADCRUMBS';
export const MTB_POP_DIRECT_BREADCRUMB = 'MTB_POP_DIRECT_BREADCRUMB';

export const MTB_INIT = {
  REQUEST: getRequestConst('MTB_INIT'),
  SUCCESS: getSuccessConst('MTB_INIT'),
  FAIL: getFailConst('MTB_INIT')
};

export const MTB_VOLUME = {
  REQUEST: getRequestConst('MTB_VOLUME'),
  SUCCESS: getSuccessConst('MTB_VOLUME'),
  FAIL: getFailConst('MTB_VOLUME')
};

export const MTB_LEVELS = {
  REQUEST: getRequestConst('MTB_LEVELS'),
  SUCCESS: getSuccessConst('MTB_LEVELS'),
  FAIL: getFailConst('MTB_LEVELS')
};

export const MTB_UNILEVEL = {
  REQUEST: getRequestConst('MTB_UNILEVEL'),
  SUCCESS: getSuccessConst('MTB_UNILEVEL'),
  FAIL: getFailConst('MTB_UNILEVEL')
};

export const MTB_GET_ROOT_TEAM_MEMBER = {
  REQUEST: getRequestConst('MTB_GET_ROOT_TEAM_MEMBER'),
  SUCCESS: getSuccessConst('MTB_GET_ROOT_TEAM_MEMBER'),
  FAIL: getFailConst('MTB_GET_ROOT_TEAM_MEMBER')
};

export const MTB_GET_DIRECT_MEMBERS = {
  REQUEST: getRequestConst('MTB_GET_DIRECT_MEMBERS'),
  SUCCESS: getSuccessConst('MTB_GET_DIRECT_MEMBERS'),
  FAIL: getFailConst('MTB_GET_DIRECT_MEMBERS')
};

export const MTB_GET_DIRECT_LEG_USERS = {
  REQUEST: getRequestConst('MTB_GET_DIRECT_LEG_USERS'),
  SUCCESS: getSuccessConst('MTB_GET_DIRECT_LEG_USERS'),
  FAIL: getFailConst('MTB_GET_DIRECT_LEG_USERS')
};

export const MTB_GET_BOTTOM_TEAM_MEMBER = {
  REQUEST: getRequestConst('MTB_GET_BOTTOM_TEAM_MEMBER'),
  SUCCESS: getSuccessConst('MTB_GET_BOTTOM_TEAM_MEMBER'),
  FAIL: getFailConst('MTB_GET_BOTTOM_TEAM_MEMBER')
};

export const MTB_ADD_NEW_MEMBER_MODAL = {
  OPEN: getOpenConst('MTB_ADD_NEW_MEMBER_MODAL'),
  CLOSE: getCloseConst('MTB_ADD_NEW_MEMBER_MODAL')
};

export const Position = {
  L: 0,
  R: 1
};

export const StructureType = {
  TEAM: 0,
  TRADING: 1
};

export const GET_CUSTOMERS_PERSONAL = {
  REQUEST: getRequestConst('GET_CUSTOMERS_PERSONAL'),
  SUCCESS: getSuccessConst('GET_CUSTOMERS_PERSONAL'),
  FAIL: getFailConst('GET_CUSTOMERS_PERSONAL')
};

export const GET_CUSTOMERS_TEAM = {
  REQUEST: getRequestConst('GET_CUSTOMERS_TEAM'),
  SUCCESS: getSuccessConst('GET_CUSTOMERS_TEAM'),
  FAIL: getFailConst('GET_CUSTOMERS_TEAM')
};

export const GET_CUSTOMERS_ORDERS = {
  REQUEST: getRequestConst('GET_CUSTOMERS_ORDERS'),
  SUCCESS: getSuccessConst('GET_CUSTOMERS_ORDERS'),
  FAIL: getFailConst('GET_CUSTOMERS_ORDERS')
};

export const GET_CUSTOMERS_DETAILS = {
  REQUEST: getRequestConst('GET_CUSTOMERS_DETAILS'),
  SUCCESS: getSuccessConst('GET_CUSTOMERS_DETAILS'),
  FAIL: getFailConst('GET_CUSTOMERS_DETAILS')
};

export const GET_CUSTOMERS_ORDER_DETAILS = {
  REQUEST: getRequestConst('GET_CUSTOMERS_ORDER_DETAILS'),
  SUCCESS: getSuccessConst('GET_CUSTOMERS_ORDER_DETAILS'),
  FAIL: getFailConst('GET_CUSTOMERS_ORDER_DETAILS')
};

export const ADD_EMAIL_TO_NEW_MEMBER = {
  REQUEST: getRequestConst('ADD_EMAIL_TO_NEW_MEMBER'),
  SUCCESS: getSuccessConst('ADD_EMAIL_TO_NEW_MEMBER'),
  FAIL: getFailConst('ADD_EMAIL_TO_NEW_MEMBER')
};

export const GET_USER_SETTINGS_REQUEST = 'GET_USER_SETTINGS_REQUEST';
export const GET_USER_SETTINGS_SUCCESS = 'GET_USER_SETTINGS_SUCCESS';
export const GET_USER_SETTINGS_FAIL = 'GET_USER_SETTINGS_FAIL';

export const UPDATE_USER_SETTINGS_REQUEST = 'UPDATE_USER_SETTINGS_REQUEST';
export const UPDATE_USER_SETTINGS_SUCCESS = 'UPDATE_USER_SETTINGS_SUCCESS';
export const UPDATE_USER_SETTINGS_FAIL = 'UPDATE_USER_SETTINGS_FAIL';

export const REMOVE_MY_TEAM_STATE = 'REMOVE_MY_TEAM_STATE';
